import { useState, useEffect, useMemo } from "react";
import { Modal } from "@mui/material";
import { CashDrawerIcon, CrossIcon } from "assets/icons";
import { useDispatch, useSelector } from "react-redux";
import { verifyPinRequest } from "../../redux-store/slices/LoginSlice";
import { postActivityLog } from "redux-store/slices/NotificationsSlice";
import { WarningAmber } from "@mui/icons-material";
import DropDownContainer from "commonComponents/DropDown";

const CashDrawerModal = ({ open, onClose, onSubmit }) => {
  const [pin, setPin] = useState("");
  const [reason, setReason] = useState("");
  const [error ,setError] = useState("");
  const dispatch = useDispatch();
  const businessUserId = useSelector((state) => state.businessStore?.userData?.businessUserId || "");
  const reasonList = useSelector((state) => state.businessStore?.businessData?.cashDrawingReasons);
  const formattedReasonList = useMemo(() => {
    if (!reasonList) return [];
    return reasonList?.map((reason) => ({ mode: reason }))
  }, [reasonList]);
  const handleSubmit = () => {
    if (pin.length !== 4 || !reason) return;
    const payload = {
      uid: businessUserId, 
      pin: pin,
      callback: (res) => {
        if (res?.verified) {
          const logPayload = {
            activityLog: {
              type: "MANUAL_CASH_DRAWER_OPEN",
              group: "CASH_DRAWER",
              extra: {
                reason: reason,
              }
            },
            featureSet: "CASH_DRAWER"
          };
          dispatch(postActivityLog(logPayload));
          onSubmit({ pin, reason, businessUserId });
          handleClose();
          return;
        }
        setPin("");
        setReason("");
        setError(res?.message || res?.code || "");
      }
    };

    dispatch(verifyPinRequest(payload));
  };

  const handleClose = () => {
    setPin("");
    setReason("");
    setError("");
    onClose();
  };

  const isButtonDisabled = pin.length !== 4 || !reason;

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="fixed inset-0 flex items-center justify-center p-15">
        <div className="relative w-[450px] min-h-[500px] rounded-2xl bg-[#F5F5F5] px-8 py-7 shadow-xl">

          {/* Close */}
          <button
            onClick={handleClose}
            className="absolute right-10 top-10 text-gray-500 hover:text-gray-700 text-xl"
          >
            <CrossIcon />
          </button>

          {/* Icon */}
          <div className="flex justify-center mb-3 pt-60">
           <CashDrawerIcon bgcolor="gray" width="60" height="60" />
          </div>

          <h2 className="text-center text-[20px] font-semibold mb-2 px-10">
            Enter PIN & Reason to Open Cash Drawer
          </h2>

          <div className="pr-50 pl-50">
            <div>
              <input
                type="password"
                maxLength={4}
                placeholder="Enter 4 digit PIN*"
                value={pin}
                onChange={(e) => {
                  setPin(e.target.value);
                }}
                className="mt-3 w-full h-[44px] mb-4 p-5 border border-gray-300 px-4 text-[16px] bg-[#F9FAFB] focus:border-blue-500 focus:outline-none disabled:bg-gray-200"
              />
             {(error &&<span className="text-red-600 text-12 items-center"><WarningAmber className="text-12"/> Invalid pin</span>)}
            </div>
            <DropDownContainer
              type="text"
              uniqueKey="mode"
              disabled={!formattedReasonList?.length}
              setValueOnMount={false}
              itemTextKey="mode"
              preSelectedValue={reason}
              placeholder="Select Reason"
              listData={formattedReasonList}
              parentFunc={(val) => setReason(val)}
              customMargin="10px 0px 20px 0px"
              widthVal="100%"
              />
            <button
              onClick={handleSubmit}
              disabled={isButtonDisabled}
              className={`mt-20 w-full h-[35px] text-white text-[16px] font-medium transition-colors ${isButtonDisabled ? "bg-gray-400 cursor-not-allowed" : "bg-[#4A7BE5] hover:bg-[#3f6fd4]"
                }`}
            >
              Open Cash Drawer
            </button>

            <button
              onClick={handleClose}
              className="mt-3 w-full h-[35px] border border-gray-300 bg-[#F3F4F6] text-gray-700 text-[16px] font-medium hover:bg-gray-200"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CashDrawerModal;